import { BadgeCheck } from "lucide-react";

/**
 * VendorTrustBadge — a small green pill shown next to vendor names on
 * private-party booking dialogs, vendor cards, and public vendor pages.
 *
 * Signals that the vendor completed the 2-layer lite verification path
 * (email + phone). NOT the same as organizer ID-verification — vendors
 * intentionally have a lighter friction floor.
 */
export default function VendorTrustBadge({ verified, compact = false }) {
  if (!verified) return null;
  return (
    <span
      data-testid="vendor-trust-badge"
      className="inline-flex items-center gap-1 rounded-full text-[10px] uppercase tracking-widest font-semibold px-2 py-0.5"
      style={{
        backgroundColor: "rgba(132,204,22,0.15)",
        color: "#4B7A0A",
        border: "1.5px solid #84CC16",
      }}
      title="Trust-Verified: this vendor confirmed their email + phone"
    >
      <BadgeCheck className="h-3 w-3" />
      {compact ? "Verified" : "Trust-Verified"}
    </span>
  );
}
